import Config from "./config/config";
import Locale from './config/locale';

export default {
  modules: {
    authentication: {
      strict: true,
      namespaced: true,
      state: {
        authToken: Config.getCookie("auth") != "" ? Config.getCookie("auth") : null,
        name: Config.getCookie("name") != "" ? Config.getCookie("name") : null,
		  accountType: Config.getCookie("tp") != "" ? Config.getCookie("tp") : null,
        loggedIn: Config.getCookie("auth") != "" ? true : false,
      },
      mutations: {
        login (state, data) {
          state.loggedIn = true
        }
      }
    },
	 locale: {
      strict: true,
      namespaced: true,
      state: {
		  lang: Config.getCookie("lang") != "" ? Config.getCookie("lang") : 'km',
		  locale: Locale
      },
      mutations: {
		  changeLanguage(state, data) {
			  state.lang = data

		  }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store.js